import { render } from "./DatingSection.vue?vue&type=template&id=3d4bc0d9&scoped=true"
import script from "./DatingSection.vue?vue&type=script&lang=js"
export * from "./DatingSection.vue?vue&type=script&lang=js"

import "./DatingSection.vue?vue&type=style&index=0&id=3d4bc0d9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d4bc0d9"]])

export default __exports__